import React from "react";
import TableBody from "./TableBody";
import TableHead from "./TableHead";
import { useSortTable } from "utils/useSortTable";
import "./styles.scss";

const Table = ({ data, columns }) => {
  const [tableData, handleSorting] = useSortTable(data, columns);

  return (
    <div className="table__wrapper">
      <table className="table__table">
        <TableHead {...{ columns, handleSorting }} />
        <TableBody {...{ columns, tableData }} />
      </table>
    </div>
  );
};

export default Table;
